import gsap from "@lib/gsap";
import { onDestroy } from "./_";

export default function (element, dataset) {
  const direction = dataset.direction;

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
      scrub: 1,
    },
    defaults: {
      ease: "none",
    },
  });

  if (direction === "horizontal") {
    tl.to(element, {
      x: 64,
    });
  } else {
    tl.fromTo(
      element,
      {
        y: -24,
      },
      {
        y: 24,
      },
    );
  }
}
